// import "styles/index.scss"
import "styles/globals.css"

import GlobalStyles from "@styles/GlobalStyles"
import { MARKETING_FIELDS } from "lib/constants"
import { createCookie } from "lib/cookies"
import type { AppProps } from "next/app"
import { useRouter } from "next/router"
import { appWithTranslation } from "next-i18next"
import { useEffect, useMemo, useState } from "react"
// import GlobalStyles from "styles/GlobalStyles"

/**
 * Fix for Chrome: Turns off transitions during load to prevent
 * transition animations from unstyled content to styled content.
 * See: https://github.com/vercel/next.js/issues/25487
 */
const ChromeFixUnstyledTransitions = () => {
  const [allowTransitions, setAllowTransitions] = useState(false)

  // Run this once during render.
  useMemo(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("load", function () {
        setAllowTransitions(true)
      })
    }
  }, [])

  if (allowTransitions) {
    return null
  }

  return (
    <style
      dangerouslySetInnerHTML={{
        __html: ` *, *::before, *::after { transition: none!important; } `,
      }}
    />
  )
}

if (typeof String.prototype.replaceAll === "undefined") {
  // @ts-ignore
  String.prototype.replaceAll = function (
    search: string | RegExp,
    replace: string
  ) {
    if (search instanceof RegExp) {
      if (!search.global) {
        throw new TypeError(
          "String.prototype.replaceAll called with a non-global RegExp argument"
        )
      }
      return this.replace(search, replace)
    }
    return this.split(search).join(replace)
  }
}

function App({ Component, pageProps }: AppProps) {
  const { query, isReady } = useRouter()

  useEffect(() => {
    if (!isReady) return

    MARKETING_FIELDS.forEach(field => {
      const value = query[field]
      if (value) {
        const parsedValue = typeof value === "string" ? value : value.join(",")

        createCookie(field, parsedValue)
        localStorage.setItem(field, parsedValue)
      }
    })
  }, [isReady, query])

  return (
    <>
      <GlobalStyles />
      <Component {...pageProps} />
      {/* <ChromeFixUnstyledTransitions /> */}
    </>
  )
}

export default appWithTranslation(App)
